module.exports = __webpack_public_path__ + "img/icon negro.53c04e37.png";